import React, { useState } from 'react';
import { Modal, Box, Typography, Button, Link, IconButton } from '@mui/material';
import { AiOutlineCloseCircle } from "react-icons/ai";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

interface Props {
    imagen: string,
    enlace: string,
    isOpen: boolean;
    cerrarModal: (estado: boolean) => void;
}

const ImageModal: React.FC<Props> = ({ imagen, enlace = "", isOpen, cerrarModal }) => {

    return (
        <div>
            <Modal
                open={isOpen}
                onClose={() => cerrarModal(false)}
                aria-labelledby="image-modal-title"
                aria-describedby="image-modal-description"
                // BackdropProps={{
                //     onClick: (e) => e.stopPropagation(), // Evita que se cierre al hacer clic fuera
                // }}
            >
                <Box sx={style}>
                    <IconButton
                        aria-label="close"
                        onClick={() => cerrarModal(false)}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                        color='error'
                    >
                        <AiOutlineCloseCircle />
                    </IconButton>
                    <Link href={enlace} target="_blank" rel="noopener" sx={{ mt: 2, display: 'block' }}>
                        <img
                            src={imagen}
                            alt="Example"
                            style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}
                        />
                    </Link>
                </Box>
            </Modal>
        </div>
    );
};

export default ImageModal;
